import angular from 'angular';

import translationModuleName from '../translation';
import logServiceModule from './LogService';

const moduleName = 'recaps.services.ThemeSwitcherService';
const module = angular.module(moduleName, [
  translationModuleName,
  logServiceModule.name,
]);

const themes = {
  light: {
    key: "LIGHT_THEME",
    cssClass: "",
  },
  dark: {
    key: "DARK_THEME",
    cssClass: "dark",
  },
};

const defaultTheme = 'light';
const alternateTheme = 'dark';

class ThemeSwitcherService {
  constructor(
    $window,
    $q,
    $translate,
    $rootScope,
    LogService
  ) {
    this.$window = $window;
    this.$q = $q;
    this.$translate = $translate;
    this.$rootScope = $rootScope;
    this.LogService = LogService;
    this._currentTheme = defaultTheme;
    this._updateTranslatedThemeName();

    this.$rootScope.$on('LanguageServiceChangedLanguage', () => this._updateTranslatedThemeName());
  }

  get currentTheme() {
    return this._currentTheme;
  }
  get oppositeThemeName() {
    if (this.currentTheme === defaultTheme) {
      return alternateTheme;
    }
    return defaultTheme;
  }

  get translatedThemeName() {
    return this._translatedThemeName;
  }

  switchToTheme(theme) {
    if (theme !== this._currentTheme) {
      const newThemeInfo = themes[theme];
      if (!newThemeInfo) {
        this.LogService.warn(`ThemeSwitcherService.switchToTheme() attempting to switch to invalid theme:`, theme);
        return this.$q.reject("Invalid theme");
      }
      const oldThemeInfo = themes[this.currentTheme];
      if (oldThemeInfo.cssClass) {
        this._removeCSSClass(oldThemeInfo.cssClass);
      }
      if (newThemeInfo.cssClass) {
        this._addCSSClass(newThemeInfo.cssClass);
      }
      this._currentTheme = theme;
      return this._updateTranslatedThemeName()
        .then(() => theme);
    } else {
      return this.$q.when(this.currentTheme);
    }
  }

  toggleTheme() {
    if (this.currentTheme === defaultTheme) {
      return this.switchToTheme(alternateTheme);
    } else {
      return this.switchToTheme(defaultTheme);
    }
  }

  _jquery() {
    return this.$window.jQuery;
  }

  _removeCSSClass(cssClass) {
    this.LogService.debug(`ThemeSwitcherService._removeCSSClass(${cssClass})`);
    const $ = this._jquery();
    $('body').removeClass(cssClass);
  }

  _addCSSClass(cssClass) {
    this.LogService.debug(`ThemeSwitcherService._addCSSClass(${cssClass})`);
    const $ = this._jquery();
    $('body').addClass(cssClass);
  }

  _updateTranslatedThemeName() {
    const themeKey = themes[this.currentTheme].key;
    return this.$translate(themeKey)
      .then(translated => {
        this._translatedThemeName = translated;
        return translated;
      });
  }
}

module.service('ThemeSwitcherService', ThemeSwitcherService);
export default module;
